import isArray from 'lodash/isArray';
import extend from 'lodash/extend';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ngHelper, currencyParser, IMultiUrlImage } from '@cakeiteasy/web-utils';
import { ISelectItem } from '../../../..';

@Component({
  standalone: false,
  selector: 'ui-cake-build-extra-products',
  templateUrl: './ui-cake-build-extra-products.component.html'
})
export class UiCakeBuildExtraProductsComponent implements OnChanges {
  @Input() products: any;
  @Input() group: any;
  @Input() selectedProducts: any;
  @Input() currency = 'kr';

  @Output() onSelect = new EventEmitter<any>();

  public selectItems: ISelectItem[];

  public pic: {
    show: boolean,
    image: IMultiUrlImage,
    offsetTop: number
  } = { show: false, offsetTop: 0, image: null };

  public onProductsSelect(products) {
    if (isArray(products)) {
      this.onSelect.emit(products);
    } else {
      this.onSelect.emit([products]);
    }
  }

  public ngOnChanges(changes: SimpleChanges) {
    ngHelper.ifChanged(changes, 'products', (products) => {
      this.selectItems = products.map((p) => {
        return {
          label: p.name,
          priceLabel: (p.hidePrice || p.price < 1) ? '' : currencyParser(p.price, this.currency),
          value: p,
          ref: p,
          isDefaultValue: p.id === 0
        };
      });
    });
  }

  public imageSelect(pictureData) {
    this.pic = extend({ show: true }, pictureData);
  }
}
